export enum OpenFieldTypeEnum {
  Textbox,
  Dropdown,
  CheckboxList,
}
